(function () {
  'use strict';

  // Mide el alto real de la cinta superior (ticker) y lo expone como variable
  // CSS, para que el header nativo de Dawn (sticky_header_type: on-scroll-up)
  // se posicione justo debajo de ella al reaparecer, en vez de superponerse.
  function initTickerAlto() {
    var ticker = document.querySelector('.mt-ticker');
    if (!ticker) return;
    function medir() {
      document.documentElement.style.setProperty('--mt-ticker-alto', ticker.getBoundingClientRect().height + 'px');
    }
    medir();
    window.addEventListener('resize', medir);
  }

  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-observed)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var observer = window.__mtRevealObserver || new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: '0px 0px -60px 0px' }
    );
    window.__mtRevealObserver = observer;
    els.forEach(function (el, i) {
      el.classList.add('mt-observed');
      if (!el.style.getPropertyValue('--mt-delay')) {
        el.style.setProperty('--mt-delay', Math.min(i * 90, 360) + 'ms');
      }
      observer.observe(el);
    });
    initRevealSafetyNet();
  }

  // Red de seguridad: si un salto de scroll rápido (ancla, tecla Fin, flick)
  // hace que un elemento nunca llegue a "intersectar" mientras se observa,
  // se quedaría con opacity:0 para siempre. Revisamos periódicamente y
  // revelamos cualquier elemento que ya haya quedado por encima del borde
  // inferior de la pantalla, aunque el observer se lo haya saltado.
  function initRevealSafetyNet() {
    if (window.__mtRevealSafetyNet) return;
    window.__mtRevealSafetyNet = true;
    var ticking = false;
    function revisar() {
      ticking = false;
      var pendientes = document.querySelectorAll('.mt-reveal.mt-observed:not(.mt-visible)');
      pendientes.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight + 40) {
          el.classList.add('mt-visible');
        }
      });
    }
    function onScrollOrResize() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(revisar);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    window.addEventListener('hashchange', function () { setTimeout(revisar, 350); });
    setTimeout(revisar, 400);
  }

  function initGalerias() {
    document.querySelectorAll('[data-mt-galeria]').forEach(function (galeria) {
      if (galeria.dataset.mtInit) return;
      galeria.dataset.mtInit = '1';
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var principalImg = principal ? principal.querySelector('img') : null;
      var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
      minis.forEach(function (mini) {
        mini.addEventListener('click', function () {
          var src = mini.getAttribute('data-full');
          var alt = mini.getAttribute('data-alt') || '';
          var ratio = mini.getAttribute('data-ratio');
          if (!src || !principalImg) return;
          principalImg.setAttribute('src', src);
          principalImg.setAttribute('alt', alt);
          if (principal && ratio) principal.style.setProperty('--mt-galeria-ratio', ratio);
          minis.forEach(function (m) { m.classList.remove('is-active'); });
          mini.classList.add('is-active');
        });
      });
    });
  }

  function initVariantes() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      if (root.dataset.mtInit) return;
      root.dataset.mtInit = '1';

      var dataEl = root.querySelector('[data-mt-variantes-json]');
      if (!dataEl) return;
      var variantes;
      try {
        variantes = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }

      var idInput = root.querySelector('[data-mt-variant-id]');
      var precioEl = root.querySelector('[data-mt-precio-actual]');
      var precioAntesEl = root.querySelector('[data-mt-precio-antes]');
      var btnComprar = root.querySelector('[data-mt-btn-comprar]');
      var stockNota = root.querySelector('[data-mt-stock-nota]');
      var pills = root.querySelectorAll('[data-mt-pill]');

      function opcionesSeleccionadas() {
        var seleccion = {};
        root.querySelectorAll('[data-mt-opcion]').forEach(function (bloque) {
          var activo = bloque.querySelector('.mt-pill.is-active');
          if (activo) seleccion[bloque.getAttribute('data-mt-opcion')] = activo.getAttribute('data-valor');
        });
        return seleccion;
      }

      function encontrarVariante(seleccion) {
        return variantes.find(function (v) {
          return v.opciones.every(function (val, i) { return val === seleccion[v.nombres[i]]; });
        });
      }

      function formatoMoneda(centavos) {
        return (centavos / 100).toLocaleString(document.documentElement.lang || 'es', {
          style: 'currency',
          currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD',
        });
      }

      function actualizar() {
        var seleccion = opcionesSeleccionadas();
        var variante = encontrarVariante(seleccion) || variantes[0];
        if (!variante) return;

        pills.forEach(function (pill) {
          var opcionId = pill.closest('[data-mt-opcion]').getAttribute('data-mt-opcion');
          var valor = pill.getAttribute('data-valor');
          var pruebaSeleccion = Object.assign({}, seleccion);
          pruebaSeleccion[opcionId] = valor;
          var existe = encontrarVariante(pruebaSeleccion);
          pill.disabled = !existe || !existe.disponible;
        });

        if (idInput) idInput.value = variante.id;
        if (precioEl) precioEl.textContent = formatoMoneda(variante.precio);
        if (precioAntesEl) {
          if (variante.precioAntes && variante.precioAntes > variante.precio) {
            precioAntesEl.textContent = formatoMoneda(variante.precioAntes);
            precioAntesEl.style.display = '';
          } else {
            precioAntesEl.style.display = 'none';
          }
        }
        if (btnComprar) {
          btnComprar.disabled = !variante.disponible;
          btnComprar.textContent = variante.disponible
            ? btnComprar.getAttribute('data-texto-disponible')
            : btnComprar.getAttribute('data-texto-agotado');
        }
        if (stockNota) {
          stockNota.style.display = variante.disponible ? 'none' : 'block';
        }

        // Si la variante elegida tiene su propia foto asignada en el catálogo,
        // la imagen principal de la galería cambia para reflejarla.
        if (variante.imagenUrl) {
          var principalImg = root.querySelector('[data-mt-galeria-principal] img');
          if (principalImg && principalImg.getAttribute('src') !== variante.imagenUrl) {
            principalImg.setAttribute('src', variante.imagenUrl);
            principalImg.setAttribute('alt', variante.imagenAlt || '');
          }
          if (variante.imagenId) {
            root.querySelectorAll('[data-mt-galeria-mini]').forEach(function (m) {
              m.classList.toggle('is-active', m.getAttribute('data-media-id') === variante.imagenId);
            });
          }
        }
      }

      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          if (pill.disabled) return;
          pill.closest('[data-mt-opcion]').querySelectorAll('.mt-pill').forEach(function (p) {
            p.classList.remove('is-active');
          });
          pill.classList.add('is-active');
          actualizar();
        });
      });

      actualizar();
    });
  }

  function prefiereMenosMovimiento() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  // Botones magnéticos: se desplazan un poco hacia el cursor al pasar por
  // encima, dan sensación de tacto premium. Se desactiva en móvil (sin hover)
  // y si el usuario prefiere menos animaciones.
  function initMagnetic() {
    if (prefiereMenosMovimiento() || window.matchMedia('(hover: none)').matches) return;
    document.querySelectorAll('.mt-btn:not([data-mt-magnet-init])').forEach(function (btn) {
      btn.setAttribute('data-mt-magnet-init', '1');
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = (e.clientX - r.left - r.width / 2) * 0.18;
        var y = (e.clientY - r.top - r.height / 2) * 0.35;
        btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  // Paralaje suave del cierre: la imagen se mueve un poco más despacio que
  // el scroll, dando profundidad. Solo transform, va por GPU.
  function initParallaxCta() {
    if (prefiereMenosMovimiento()) return;
    var medias = document.querySelectorAll('.mt-cta-media img');
    if (!medias.length) return;
    var ticking = false;
    function aplicar() {
      ticking = false;
      medias.forEach(function (img) {
        var wrap = img.closest('.mt-cta-wrap');
        if (!wrap) return;
        var r = wrap.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        var centro = r.top + r.height / 2 - window.innerHeight / 2;
        var desplazamiento = Math.max(-24, Math.min(24, centro * -0.06));
        img.style.transform = 'translateY(' + desplazamiento + 'px) scale(1.08)';
      });
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(aplicar);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    aplicar();
  }

  // Hero: paralaje muy sutil de la foto al scrollear (se mueve un poco más
  // despacio que el resto de la página, dando profundidad). Nada de
  // flotación continua ni reacción al cursor: es una foto de estilo de vida,
  // no un producto aislado, así que el movimiento es mínimo y discreto.
  function initHeroExperiencia() {
    var foto = document.querySelector('[data-mt-hero-foto-parallax]');
    if (!foto || foto.dataset.mtInit || prefiereMenosMovimiento()) return;
    foto.dataset.mtInit = '1';
    var img = foto.querySelector('img');
    if (!img) return;

    var ticking = false;
    function aplicar() {
      ticking = false;
      var r = foto.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var centro = r.top + r.height / 2 - window.innerHeight / 2;
      var desplazamiento = Math.max(-18, Math.min(18, centro * -0.04));
      img.style.transform = 'translateY(' + desplazamiento.toFixed(2) + 'px) scale(1.02)';
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(aplicar);
    }, { passive: true });
    aplicar();
  }

  // Barra flotante de "añadir al carrito": aparece cuando el botón de compra
  // principal sale de la pantalla, para que comprar siga a un clic aunque el
  // usuario haya bajado a leer características o reseñas.
  function initStickyBar() {
    var root = document.querySelector('[data-mt-producto]');
    var barra = document.querySelector('[data-mt-sticky-bar]');
    if (!root || !barra || barra.dataset.mtInit) return;
    barra.dataset.mtInit = '1';

    var btnOriginal = root.querySelector('[data-mt-btn-comprar]');
    var btnBarra = barra.querySelector('[data-mt-sticky-comprar]');
    if (btnOriginal && btnBarra) {
      btnBarra.addEventListener('click', function () {
        btnOriginal.click();
      });
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          barra.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      if (btnOriginal) obs.observe(btnOriginal);
    }
  }

  // Barra flotante de compra en la PORTADA: aparece cuando el botón
  // principal del hero sale de la pantalla, para no obligar a volver arriba
  // para comprar. Reutiliza el mismo estilo .mt-sticky-bar del producto.
  function initStickyBarHome() {
    var barra = document.querySelector('[data-mt-sticky-bar-home]');
    var objetivo = document.querySelector('[data-mt-hero-cta-observar]');
    if (!barra || !objetivo || barra.dataset.mtInit) return;
    barra.dataset.mtInit = '1';
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          barra.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 });
      obs.observe(objetivo);
    }
  }

  // Comparador antes/después: el input range nativo queda solo para
  // accesibilidad (foco + flechas de teclado); el arrastre real con
  // mouse/dedo lo controla este código directamente sobre todo el recuadro,
  // así funciona igual en todos los navegadores sin depender de como cada
  // uno dibuje el "thumb" invisible del range (eso fallaba al arrastrar).
  function initComparador() {
    document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
      if (wrap.dataset.mtInit) return;
      wrap.dataset.mtInit = '1';
      var range = wrap.querySelector('.mt-comparador-range');
      if (!range) return;

      function fijarPorcentaje(pct) {
        pct = Math.max(0, Math.min(100, pct));
        range.value = pct;
        wrap.style.setProperty('--mt-pos', pct + '%');
      }

      function porcentajeDesdeEvento(e) {
        var r = wrap.getBoundingClientRect();
        return ((e.clientX - r.left) / r.width) * 100;
      }

      var arrastrando = false;

      wrap.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        if (wrap.setPointerCapture) {
          try { wrap.setPointerCapture(e.pointerId); } catch (err) {}
        }
        fijarPorcentaje(porcentajeDesdeEvento(e));
      });
      wrap.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        fijarPorcentaje(porcentajeDesdeEvento(e));
      });
      ['pointerup', 'pointercancel'].forEach(function (ev) {
        wrap.addEventListener(ev, function () { arrastrando = false; });
      });

      range.addEventListener('input', function () {
        wrap.style.setProperty('--mt-pos', range.value + '%');
      });

      var valorInicial = parseFloat(range.value) || 50;
      fijarPorcentaje(valorInicial);

      // Demostración automática: al entrar en pantalla, el deslizador se
      // mueve solo una vez para "enseñar" el resultado, y vuelve a su sitio
      // dejando el control al usuario. Un solo IntersectionObserver, se
      // desconecta tras usarse. Se omite con menos-movimiento activado.
      if (wrap.dataset.mtComparadorDemo === '1' && !prefiereMenosMovimiento() && 'IntersectionObserver' in window) {
        var yaHizoDemo = false;
        var obsDemo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !yaHizoDemo) {
              yaHizoDemo = true;
              obsDemo.disconnect();
              setTimeout(function () { animarDemo(valorInicial); }, 500);
            }
          });
        }, { threshold: 0.55 });
        obsDemo.observe(wrap);
      }

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function animarDemo(valorBase) {
        if (arrastrando) return;
        var destino = Math.min(85, valorBase + 30);
        var duracionIda = 1000;
        var duracionVuelta = 900;
        var inicio = null;

        function pasoIda(ts) {
          if (arrastrando) return;
          if (!inicio) inicio = ts;
          var t = Math.min(1, (ts - inicio) / duracionIda);
          fijarPorcentaje(valorBase + (destino - valorBase) * easeInOutCubic(t));
          if (t < 1) requestAnimationFrame(pasoIda);
          else { inicio = null; requestAnimationFrame(pasoVuelta); }
        }
        function pasoVuelta(ts) {
          if (arrastrando) return;
          if (!inicio) inicio = ts;
          var t = Math.min(1, (ts - inicio) / duracionVuelta);
          fijarPorcentaje(destino + (valorBase - destino) * easeInOutCubic(t));
          if (t < 1) requestAnimationFrame(pasoVuelta);
        }
        requestAnimationFrame(pasoIda);
      }
    });
  }

  // Sección de beneficios con modelo central: la foto reacciona muy
  // levemente a la posición del cursor (parallax + resplandor que la sigue),
  // y cada tarjeta se puede "fijar" abierta con un toque/clic — así en
  // móvil (sin hover) también se puede leer el texto ampliado.
  function initBeneficiosModelo() {
    document.querySelectorAll('[data-mt-bm]').forEach(function (escenario) {
      if (escenario.dataset.mtInit) return;
      escenario.dataset.mtInit = '1';

      var imagen = escenario.querySelector('.mt-bm-imagen');
      var puedeHover = window.matchMedia('(hover: hover)').matches;
      if (imagen && puedeHover && !prefiereMenosMovimiento()) {
        escenario.addEventListener('mousemove', function (e) {
          var r = escenario.getBoundingClientRect();
          var mx = ((e.clientX - r.left) / r.width - 0.5) * 2;
          var my = ((e.clientY - r.top) / r.height - 0.5) * 2;
          escenario.style.setProperty('--mt-mx-pct', (50 + mx * 25) + '%');
          escenario.style.setProperty('--mt-my-pct', (38 + my * 18) + '%');
          imagen.style.transform = 'translate(' + (mx * 6).toFixed(2) + 'px,' + (my * 6).toFixed(2) + 'px) scale(1.02)';
        });
        escenario.addEventListener('mouseleave', function () {
          imagen.style.transform = '';
        });
      }

      escenario.querySelectorAll('[data-mt-bm-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          var yaAbierta = card.classList.contains('is-expandida');
          escenario.querySelectorAll('[data-mt-bm-card]').forEach(function (c) {
            c.classList.remove('is-expandida');
          });
          if (!yaAbierta) card.classList.add('is-expandida');
        });
      });
    });
  }

  // Carrusel de reseñas: loop infinito real. La sección liquid repite el
  // set de tarjetas 3 veces seguidas; este script mantiene el scroll
  // siempre dentro de la copia del medio y, apenas se sale de un margen de
  // seguridad, salta exactamente el ancho de un set hacia el lado
  // contrario — como las 3 copias son idénticas, el salto es invisible y el
  // desplazamiento se siente continuo en cualquier dirección (autoplay,
  // arrastre, touch o flechas). A propósito NO se usa scroll-snap en este
  // track: combinado con el autoplay por scrollLeft, el snap "corrige" cada
  // micro-avance y lo congela (bug ya visto). El encaje a foto queda solo
  // para las mini-galerías internas.
  function initResenasCarrusel() {
    document.querySelectorAll('[data-mt-resenas-carrusel]').forEach(function (track) {
      if (track.dataset.mtInit) return;
      track.dataset.mtInit = '1';

      var setWidth = 0;
      function medirSet() {
        var total = track.scrollWidth;
        if (total > 0) setWidth = total / 3;
      }
      medirSet();
      track.scrollLeft = setWidth;

      function envolver() {
        if (setWidth < 1) return;
        if (track.scrollLeft < setWidth * 0.5) {
          track.scrollLeft += setWidth;
        } else if (track.scrollLeft > setWidth * 1.5) {
          track.scrollLeft -= setWidth;
        }
      }
      track.addEventListener('scroll', envolver, { passive: true });

      var resizeTimeout;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(medirSet, 200);
      });

      var contenedor = track.closest('.mt-resenas');
      var anchoTarjeta = function () {
        var tarjeta = track.querySelector('.mt-resena-card');
        return tarjeta ? tarjeta.getBoundingClientRect().width + 22 : 320;
      };

      var autoplay = track.dataset.autoplay === 'true';
      var velocidad = parseFloat(track.dataset.velocidad) || 20;
      var activo = autoplay && !prefiereMenosMovimiento();
      var ultimoTs = null;
      var enHover = false;
      var reanudarTimeout = null;

      // Pausa; si "conDemora" es true, retoma sola unos segundos después
      // (arrastre/touch/flechas). Si es false, queda pausada hasta que algo
      // explícito la reactive (el hover la reanuda en mouseleave).
      function pausar(conDemora) {
        activo = false;
        if (reanudarTimeout) { clearTimeout(reanudarTimeout); reanudarTimeout = null; }
        if (conDemora) {
          reanudarTimeout = setTimeout(function () {
            if (!enHover) { activo = autoplay && !prefiereMenosMovimiento(); ultimoTs = null; }
          }, 1400);
        }
      }
      function reanudarYa() {
        if (reanudarTimeout) { clearTimeout(reanudarTimeout); reanudarTimeout = null; }
        activo = autoplay && !prefiereMenosMovimiento();
        ultimoTs = null;
      }

      // Hover: pausa y reanuda de inmediato, siempre desde el mismo punto
      // (el scrollLeft nunca se toca al pausar).
      track.addEventListener('mouseenter', function () { enHover = true; pausar(false); });
      track.addEventListener('mouseleave', function () { enHover = false; reanudarYa(); });

      // Arrastre con mouse en desktop (el táctil ya se arrastra nativo).
      var arrastrando = false, origenX = 0, origenScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        arrastrando = true;
        origenX = e.clientX;
        origenScroll = track.scrollLeft;
        pausar(false);
        track.classList.add('is-arrastrando');
        if (track.setPointerCapture) { try { track.setPointerCapture(e.pointerId); } catch (err) {} }
      });
      track.addEventListener('pointermove', function (e) {
        if (!arrastrando || e.pointerType !== 'mouse') return;
        track.scrollLeft = origenScroll - (e.clientX - origenX);
      });
      function soltarArrastre() {
        if (!arrastrando) return;
        arrastrando = false;
        track.classList.remove('is-arrastrando');
        pausar(true);
      }
      track.addEventListener('pointerup', soltarArrastre);
      track.addEventListener('pointercancel', soltarArrastre);
      track.addEventListener('touchstart', function () { pausar(false); }, { passive: true });
      track.addEventListener('touchend', function () { pausar(true); }, { passive: true });
      track.addEventListener('wheel', function () { pausar(true); }, { passive: true });

      if (contenedor) {
        var prev = contenedor.querySelector('[data-mt-resenas-prev]');
        var next = contenedor.querySelector('[data-mt-resenas-next]');
        if (prev) prev.addEventListener('click', function () {
          pausar(true);
          track.scrollBy({ left: -anchoTarjeta(), behavior: 'smooth' });
        });
        if (next) next.addEventListener('click', function () {
          pausar(true);
          track.scrollBy({ left: anchoTarjeta(), behavior: 'smooth' });
        });
      }

      if (!autoplay || prefiereMenosMovimiento()) return;

      function fotograma(ts) {
        requestAnimationFrame(fotograma);
        if (!activo) { ultimoTs = ts; return; }
        if (!ultimoTs) ultimoTs = ts;
        var dt = (ts - ultimoTs) / 1000;
        ultimoTs = ts;
        track.scrollLeft = track.scrollLeft + velocidad * dt;
      }
      requestAnimationFrame(fotograma);
    });
  }

  // Mini-galería de fotos dentro de cada tarjeta de reseña: desliza nativo
  // (dedo/trackpad) con encaje a foto, más puntos indicadores clicables que
  // se sincronizan con la foto visible.
  function initResenaGalerias() {
    document.querySelectorAll('[data-mt-resena-galeria-track]').forEach(function (track) {
      if (track.dataset.mtInit) return;
      track.dataset.mtInit = '1';

      var media = track.closest('[data-mt-resena-galeria]');
      var dots = media ? Array.prototype.slice.call(media.querySelectorAll('[data-mt-resena-galeria-dots] button')) : [];
      var imgs = Array.prototype.slice.call(track.querySelectorAll('img'));
      if (!dots.length || !imgs.length) return;

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function (e) {
          e.stopPropagation();
          var img = imgs[i];
          if (img) track.scrollTo({ left: img.offsetLeft, behavior: 'smooth' });
        });
      });
      dots[0].classList.add('is-active');

      if ('IntersectionObserver' in window) {
        var obs = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var idx = imgs.indexOf(entry.target);
            if (idx < 0) return;
            dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          });
        }, { root: track, threshold: 0.6 });
        imgs.forEach(function (img) { obs.observe(img); });
      }

      // Evita que arrastrar una foto de la galería arrastre también el
      // carrusel grande de reseñas por debajo.
      track.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    });
  }

  function initTodo() {
    initTickerAlto();
    initReveals();
    initGalerias();
    initVariantes();
    initMagnetic();
    initParallaxCta();
    initHeroExperiencia();
    initBeneficiosModelo();
    initResenaGalerias();
    initResenasCarrusel();
    initStickyBar();
    initStickyBarHome();
    initComparador();
  }

  document.addEventListener('DOMContentLoaded', initTodo, { once: true });
  document.addEventListener('shopify:section:load', initTodo);
})();
